/* istanbul ignore file */
import { InputTooltip } from 'framework/ui/layout';
import { LinkField } from 'framework/ui/field';
import { Typography } from '@mui/material';

const ArtifactStorageHashTooltip = () => {
  return (
    <InputTooltip
      message={
        <>
          <Typography variant="body2" mb={1}>
            The hash is encoded with the CRC-32 algorithm with a decimal value.
          </Typography>
          <Typography variant="body2" mb={1}>
            The CRC-32 algorithm converts a variable length string into an 8 character string.
          </Typography>
          <Typography variant="body2" mb={0}>
            For decoding, you can use online tools, for instance,
            <LinkField linkText="SimplyCalc" value="https://simplycalc.com/crc32-file.php" isInternal={false} /> (just
            upload the file and compare the received decimal value with the value in the column).
          </Typography>
        </>
      }
      source="file.artifact.hash"
      size="medium"
      sx={{ fontSize: '15px' }}
    />
  );
};

export default ArtifactStorageHashTooltip;
